import {
    Component,
    ElementRef, EventEmitter,
    HostBinding,
    Inject,
    Input,
    NgZone,
    OnChanges,
    OnDestroy,
    OnInit, Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import { RootService } from '../../services/root.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { debounceTime, finalize, map, switchMap, take, takeUntil, throttleTime } from 'rxjs/operators';
import { fromEvent, of, Subject, asyncScheduler, timer } from 'rxjs';
import { ShopService } from '../../api/shop.service';
import { Category } from '../../interfaces/category';
import { DOCUMENT } from '@angular/common';
import { CartService } from '../../services/cart.service';
import { Categoria } from '../../interfaces/custom/categoria';
import { Articolo, ArticoloFull } from '../../interfaces/custom/articolo';
import { Router } from '@angular/router';
import { CategoriaAttualeService } from '../../services/custom/categoria-attuale.service';
import { PriceArticoloService } from '../../services/custom/price-articolo.service';
import { SearchService } from '../../services/custom/search.service';
import { StoreService } from '../../services/store.service';
import { AccountService } from '../../services/custom/account.service';
import { AnalyticsService } from '../../services/analytics.service.';
import { ProductCustomizationComponent } from '../product-customization/product-customization.component';
import { BsModalService } from 'ngx-bootstrap/modal';


export type CategoryWithDepth = Category & { depth: number };
var I = 0;
@Component({
    selector: 'app-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    exportAs: 'search',
})
export class SearchComponent implements OnChanges, OnInit, OnDestroy {
     @Input() alwaysVisible: boolean = false;
    private destroy$: Subject<void> = new Subject<void>();

    form: FormGroup;

    hasSuggestions = false;

    famiglie: any[] = [];

    suggestedProducts: Articolo[] = [];

    addedToCartProducts: Articolo[] = [];

    @Output() escape: EventEmitter<void> = new EventEmitter<void>();

    @Output() closeButtonClick: EventEmitter<void> = new EventEmitter<void>();

    @HostBinding('class.search') classSearch = true;

    @HostBinding('class.search--has-suggestions') get classSearchHasSuggestions(): boolean { return this.hasSuggestions; }

    @HostBinding('class.search--suggestions-open') classSearchSuggestionsOpen = false;

    @ViewChild('input') inputElementRef: ElementRef;

    get element(): HTMLElement { return this.elementRef.nativeElement; }

    get inputElement(): HTMLElement { return this.inputElementRef.nativeElement; }

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private fb: FormBuilder,
        private elementRef: ElementRef,
        private zone: NgZone,
        private shop: ShopService,
        private cart: CartService,
        public root: RootService,
        private router: Router,
        private categoryActual: CategoriaAttualeService,
        public priceService: PriceArticoloService,
        private searchService: SearchService,
        public store: StoreService,
        public accountService : AccountService,
        private analytics : AnalyticsService,
        private modalService : BsModalService
    ) {
        this.form = this.fb.group({
            category: [null],
            query: [''],
        });

        this.categoryActual.categorie$.pipe(
            takeUntil(this.destroy$)
        ).subscribe(categories => {
            if (categories)
                this.famiglie = categories[0];
        });

        this.categoryActual.currentCategoryChanged$.subscribe(newCategory => {
            let val = newCategory ? newCategory.codicefamiglia : null;
            this.form.get('category').setValue(val);
        });

        this.searchService.searchQuery$.pipe(takeUntil(this.destroy$)).subscribe(r => {
            this.hasSuggestions = false;
            this.suggestedProducts = [];
            this.form.get('query').setValue(r, {emitEvent: false});
        })
    }

    ngOnChanges(changes: SimpleChanges): void {
        /*if (changes.location && this.location === 'header') {

        }*/
    }

    ngOnInit(): void {
        this.form.get('category').valueChanges.pipe(takeUntil(this.destroy$)).subscribe(value => {
            this.hasSuggestions = false;
            this.suggestedProducts = [];
            let queryControl = this.form.get('query');
            queryControl.setValue(queryControl.value);
        })

        // this.form.get('query').valueChanges.pipe(
        //     debounceTime(500),
        //     map(query => query ? query.trim() : null),
        //     switchMap(query => {
        //         if (query) {
        //             const category = this.form.value.category;
        //             const query = this.form.value.query;
        //             return this.shop.getArticoli(category, query, {'page_result': 7}).pipe(
        //                 map((response: any) => {
        //                     return response.body;
        //                 })
        //             );
        //         }

        //         return of([]);
        //     }),
        //     takeUntil(this.destroy$),
        // ).subscribe(products => {
        //     this.hasSuggestions = products.length > 0;

        //     if (products.length > 0) {
        //         this.suggestedProducts = products;
        //         this.analytics.mtImpressumArticoli(products);
        //     }
        // });

        this.zone.runOutsideAngular(() => {
            fromEvent(this.document, 'click').pipe(
                takeUntil(this.destroy$),
            ).subscribe(event => {
                const activeElement = this.document.activeElement;

                // If the inner element still has focus, ignore the click.
                if (activeElement && activeElement.closest('.search') === this.element) {
                    return;
                }

                // Close suggestion if click performed outside of component.
                if (event.target instanceof HTMLElement && this.element !== event.target.closest('.search')) {
                    this.zone.run(() => this.closeSuggestion());
                }
            });

            fromEvent(this.element, 'focusout').pipe(
                debounceTime(10),
                takeUntil(this.destroy$),
            ).subscribe(() => {
                if (this.document.activeElement === this.document.body) {
                    return;
                }

                // Close suggestions if the focus received an external element.
                if (this.document.activeElement && this.document.activeElement.closest('.search') !== this.element) {
                    this.zone.run(() => this.closeSuggestion());
                }
            });
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    openSuggestion(): void {
        this.classSearchSuggestionsOpen = true;
    }

    closeSuggestion(): void {
        this.classSearchSuggestionsOpen = false;
    }

    getCategoryName(category: Categoria): string {
        return category.descrizione;
    }

    addToCart(product: Articolo): void {
        if (this.addedToCartProducts.includes(product)) {
            return;
        }

        this.addedToCartProducts.push(product);

        this.shop.getArticolo(product.codart).subscribe(articolo => {
            if (articolo.non_acquistabile) {
                alert('Prodotto disponibile solo in negozio');
                this.addedToCartProducts = this.addedToCartProducts.filter(eachProduct => eachProduct !== product);
                return;
            }

            for (let i = 1; i <= 4; i++) {
                if (articolo['optionlist' + i]) {
                    this.router.navigate([this.root.product(articolo)]);
                    this.closeSuggestion();
                    this.addedToCartProducts = this.addedToCartProducts.filter(eachProduct => eachProduct !== product);
                    return;
                }
            }

            if (this.store.price == 'b2b' && articolo.confezioni_articolo.length) {
                this.router.navigate([this.root.product(articolo)]);
                this.closeSuggestion();
                this.addedToCartProducts = this.addedToCartProducts.filter(eachProduct => eachProduct !== product);
                return;
            }

            let countInCart = 0;

            let cartItem = this.cart.getCartItem(<ArticoloFull><unknown>product);

            if (cartItem)
                countInCart = cartItem.quantity;

            let countToAdd = 1;
            if (this.store.price == 'b2b') {
                if (cartItem)
                    countToAdd = articolo.livello_riordino;
                else
                    countToAdd = articolo.minimo_acquisto;
            }

            let totalAvailable = articolo.giacenze.giacenza.giacenza;
            if (!product.acquisti_giacenza_negativa && (totalAvailable - countInCart - countToAdd < 0)) {
                alert('Articolo esaurito');
                this.addedToCartProducts = this.addedToCartProducts.filter(eachProduct => eachProduct !== product);
                return;
            }

            if (articolo.tipo_articolo == 5 || articolo.tipo_articolo == 6) {
                this.shop.getArticoliComposizione(articolo.codart)
                .pipe(
                    finalize(() => {
                        this.addedToCartProducts = this.addedToCartProducts.filter(eachProduct => eachProduct !== product);
                    })
                ).subscribe(
                    r => {
                        let modalRef = this.modalService.show(ProductCustomizationComponent, {
                            class: 'modal-dialog-centered modal-xl customized-modal-dialog',
                            initialState: {
                                articolo: JSON.parse(JSON.stringify(articolo)),
                                qta: countToAdd,
                                articoli: r
                            }
                        });
                    },
                    err => {
                        alert(JSON.stringify(err));
                    }
                )

                return;
            }
            else if (articolo.attributi && articolo.attributi.length) {
                let modalRef = this.modalService.show(ProductCustomizationComponent, {
                    class: 'modal-dialog-centered modal-xl customized-modal-dialog',
                    initialState: {
                        articolo: JSON.parse(JSON.stringify(articolo)),
                        qta: countToAdd,
                    }
                });
                this.addedToCartProducts = this.addedToCartProducts.filter(eachProduct => eachProduct !== product);

                return;
            }

            this.cart.add(articolo, countToAdd).subscribe({
                complete: () => {
                    this.addedToCartProducts = this.addedToCartProducts.filter(eachProduct => eachProduct !== product);
                }
            });
        });


    }


    search() {
        const query = this.form.value.query;
        /*
        const category = this.form.value.category
        if (!query) {
            let path = basePath + (category === null ? '' : '/' + category);
            this.router.navigate([path], { queryParams: { search: query } });
            this.closeSuggestion();
            return;
        }

        this.analytics.onSearch(query);

        let path = basePath;
        this.router.navigate([path], { queryParams: { search: query } });
        this.closeSuggestion();*/

        this.analytics.onSearch(query);
        let path = "menu/search";
        this.router.navigate([path], { queryParams: { search: query } });
        
    }

    defaultText() {
        if (this.store.main_page == 'menu') {
            return 'Tutto menu';
        }
        return 'Tutte le categorie';
    }

}